import React from 'react';
import { Rect, Text } from 'react-konva';
import { fontFamily } from '../../library/constants';
import { isMobilePhone, isMobileTablet} from '../../library/calc';

const adjustTop = 24;
const adjustLeft = -2;

const highlightCycleProfilesForPedigree = ({highlight, unhighlight, cycleNodes, nodeObjs, stopStageClickPropagation}) => {
  unhighlight();
  stopStageClickPropagation({fromWhere: 'highlightCycleProfilesForPedigree'});

  cycleNodes.forEach((cycleNode)=>{
    if(typeof(nodeObjs[cycleNode].idp) !== 'undefined'){
      highlight(cycleNode);
    }
  });
  setTimeout(() => {
    unhighlight()
  }, 2000);
}

export const Oval = ({
    n,
    nodeObjs,
    cyclemaster,
    highlight,
    unhighlight,
    left,
    top,
    cursorBecomesMove,
    cursorBecomesPointer,
    cidsArr,
    animateThroughCycleNodes,
    userTouchedCycle,
    stopStageClickPropagation,
    isPedigree,
    pedigreeIsTall
  }) => {

  let width = 7;
  left += adjustLeft - 1;
  const pedigreeTop = ( pedigreeIsTall ? -8.5: -15);
  top += adjustTop + ( !isPedigree ? 2: pedigreeTop)


  return <Rect
    x={left}
    y={top}
    width={width}
    height={7}
    cursor="pointer"
    fill="#5AA92E"
    cornerRadius={3.5}

    onClick={()=>{
      if(isMobilePhone() ) return;
      if(!isPedigree){
        animateThroughCycleNodes(n, cyclemaster);
      } else{
        const cycleNodes = nodeObjs[cyclemaster].cidsArr = nodeObjs[cyclemaster].cidsArr;
        highlightCycleProfilesForPedigree({highlight, unhighlight, cycleNodes, nodeObjs, stopStageClickPropagation})
      }
    }}

    onTouchStart={()=>{
      userTouchedCycle({
        node: n,
        callback: ()=>{
          stopStageClickPropagation({fromWhere: 'cycleNodeComponent'});
          if(!isPedigree){
            animateThroughCycleNodes(n, cyclemaster);
          } else{
            const cycleNodes = nodeObjs[cyclemaster].cidsArr = nodeObjs[cyclemaster].cidsArr;
            highlightCycleProfilesForPedigree({highlight, unhighlight, cycleNodes, nodeObjs, stopStageClickPropagation})
          }
        },
        fromWhere: 'cycle oval'
      });
    }}

    onMouseenter={()=>{
      cursorBecomesPointer();
    }}

    onMouseleave={()=>{
      cursorBecomesMove();
    }}
  />;
};

export const TransparentOval = ({
    n,
    nodeObjs,
    left,
    top,
    cursorBecomesMove,
    cursorBecomesPointer,
    cyclemaster,
    highlight,
    unhighlight,
    cidsArr,
    animateThroughCycleNodes,
    userTouchedCycle,
    stopStageClickPropagation,
    isPedigree,
    pedigreeIsTall
  }) => {

  left += adjustLeft - 3.2;


  const pedigreeTop = ( pedigreeIsTall ? -10: -15);
  const deskTopTop = ( !isPedigree ? 0: pedigreeTop)

  const pedDim = ( pedigreeIsTall ? 11: 8);
  const dim = ( !isPedigree ? 11: pedDim)

  top += adjustTop + deskTopTop;

/*
  let dim = 11;
    opacity={.3}
    fill="blue"
 */


  return <Rect
    x={left}
    y={top}
    width={dim}
    height={dim}
    onTouchStart={()=>{
      userTouchedCycle({
        node: n,
        callback: ()=>{
          stopStageClickPropagation({fromWhere: 'cycleNodeComponent'});
          if(!isPedigree){
            animateThroughCycleNodes(n, cyclemaster);
          } else{
            const cycleNodes = nodeObjs[cyclemaster].cidsArr = nodeObjs[cyclemaster].cidsArr;
            highlightCycleProfilesForPedigree({highlight, unhighlight, cycleNodes, nodeObjs, stopStageClickPropagation})
          }
        },
        fromWhere: 'cycle oval'
      });
    }}

  />;
};



const CycleCount = ({
    n,
    nodeObjs,
    cyclemaster,
    highlight,
    unhighlight,
    nm,
    left,
    top,
    cursorBecomesMove,
    cursorBecomesPointer,
    cidsLength,
    cidsArr,
    animateThroughCycleNodes,
    userTouchedCycle,
    stopStageClickPropagation,
    translatedLabels,
    showToolTipFor,
    hideToolTip,
    isPedigree,
    pedigreeIsTall
  }) => {

    left += adjustLeft - 5.6;
    left = ( !pedigreeIsTall && isPedigree ? left + 2.5: left);

    const pedigreeTop = ( pedigreeIsTall ? -6.7: -13.3);
    const deskTopTop = ( !isPedigree ? 4: pedigreeTop)
    top += adjustTop + deskTopTop;
    cidsLength = 'x' + cidsLength;


    const pedDim = ( pedigreeIsTall ? 16: 11);
    const dim = ( !isPedigree ? 16: pedDim)



    return <Text
      x={left}
      y={top}
      text={cidsLength}
      // text={`X${2}`}
      fontSize={3.5}
      fontFamily={fontFamily}
      fill='white'
      width={dim}
      height={dim}
      align={`center`}

      onClick={()=>{
        if(!isPedigree){
          animateThroughCycleNodes(n, cyclemaster);
        } else{
          const cycleNodes = nodeObjs[cyclemaster].cidsArr = nodeObjs[cyclemaster].cidsArr;
          highlightCycleProfilesForPedigree({highlight,
          unhighlight, cycleNodes, nodeObjs, stopStageClickPropagation})
        }
      }}

      onTouchStart={()=>{
        userTouchedCycle({
          node: n,
          callback: ()=>{
            stopStageClickPropagation({fromWhere: 'cycleNodeComponent'});
            if(!isPedigree){
              animateThroughCycleNodes(n, cyclemaster);
            } else{
              const cycleNodes = nodeObjs[cyclemaster].cidsArr = nodeObjs[cyclemaster].cidsArr;
              highlightCycleProfilesForPedigree({highlight, unhighlight, cycleNodes, nodeObjs, stopStageClickPropagation})
            }
          },
          fromWhere: 'cycle count'
        });
      }}

      onMouseenter={()=>{
        cursorBecomesPointer();

        const content = (
          isPedigree
            ?
          "{profile} appears multiple times in this tree. Click this icon to see {profile}'s other position in the tree."
            :
          "{profile} appears multiple times in this tree. Click this icon to move to {profile}'s next position in the tree.")

        const pedigreeTop = ( pedigreeIsTall ? -10: -13.5);
        const shiftTopOnToolTip = (isPedigree ? pedigreeTop: 0);

        showToolTipFor({
          node: n,
          placement: 'under',
          shiftLeftOnToolTip:  -5.5,
          shiftTopOnToolTip,
          content,
          runTranslatePhraseInToolTip: true,
          translateVarStrInToolTip: nm,
        })

      }}

      onMouseleave={()=>{
        hideToolTip();
        cursorBecomesMove();
      }}
    />;
  };

export default ({
    n,
    nodeObjs,
    cyclemaster,
    highlight,
    unhighlight,
    nm,
    left,
    top,
    cursorBecomesMove,
    cursorBecomesPointer,
    cidsLength,
    animateThroughCycleNodes,
    userTouchedCycle,
    stopStageClickPropagation,
    translatedLabels,
    showToolTipFor,
    hideToolTip,
    isPedigree,
    pedigreeIsTall,
    cidsArr,
  }) => {


  const props = {
    n,
    nodeObjs,
    cyclemaster,
    nm,
    left,
    top,
    cursorBecomesMove,
    cursorBecomesPointer,
    cidsLength,
    animateThroughCycleNodes,
    userTouchedCycle,
    stopStageClickPropagation,
    translatedLabels,
    showToolTipFor,
    hideToolTip,
    isPedigree,
    pedigreeIsTall,
    cidsArr,
    highlight,
    unhighlight
  };

  let multiCycleComponents =  [
      <Oval key={Math.random()} {...props} />,
      <CycleCount key={Math.random()} {...props} />,
    ];

  if(isMobilePhone() || isMobileTablet() ) multiCycleComponents.push(
      <TransparentOval key={Math.random()} {...props} />,
  );

  return multiCycleComponents;
};

